module.exports = ".info-area {\r\n    margin: 10px;\r\n}\r\n\r\n.reset {\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-detail/user-detail.component.css
// module id = 623
// module chunks = 1